import request from '@/utils/request'

let materialApi = {

  /*物料分类列表*/
  // http://spa.conn/shop/material.Category/index
  catList(data, errorback) {
    // material.Category/index
    return request._get('/shop/material.Category/index', data, errorback);
  },
  /*物料分类添加*/
  catecatAdd(data, errorback) {
    // material.Category/add
    return request._post('/shop/material.Category/add', data, errorback);
  },
  /*物料分类删除*/
  // http://spa.conn/shop/material.Category/delete
  catDel(data, errorback) {
    return request._post('/shop/material.Category/delete', data, errorback);
  },
  // 物料分类详情
  // http://spa.conn/shop/material.Category/detailData?material_id=64
  catdetail(data, errorback) {
    return request._get('/shop/material.Category/detailData', data, errorback);
  },
  /*物料分类编辑*/
  // http://spa.conn/shop/material.Category/edit
  catEdit(data, errorback) {
    return request._post('/shop/material.Category/edit', data, errorback);
  },
  // 物料分类状态更改
  // http://spa.conn/shop/material.Category/updateStatus
  changeStatus(data, errorback) {
    return request._post('/shop/material.Category/updateStatus', data, errorback);
  },
  /*物料列表*/
  // http://spa.conn/shop/material.material/lists?name=物料
  productList(data, errorback) {
    return request._get('/shop/material.material/lists', data, errorback);
  },
  /*物料添加*/
  // http://spa.conn/shop/material.material/add/
  addProduct(data, errorback) {
    return request._post('/shop/material.material/add', data, errorback);
  },

  // /*产品基础数据*/
  // getBaseData(data, errorback) {
  //     return request._get('/shop/product.product/add', data, errorback);
  // },
  /*物料删除*/
  // http://spa.conn/shop/material.material/delete
  delProduct(data, errorback) {
    return request._post('/shop/material.material/delete', data, errorback);
  },
  // 物料编辑
  // http://spa.conn/shop/material.material/edit
  editProduct(data, errorback) {
    return request._post('/shop/material.material/edit', data, errorback);
  },
  // http://spa.conn/shop/material.material/detail?material_id=1
  materialdetail(data, errorback) {
    return request._get('/shop/material.material/detail', data, errorback);
  },
  /*得到分类图片*/
  // cateImage(data, errorback) {
  //     return request._post('/shop/product.category/image', data, errorback);
  // },
  /*物料订单列表*/
  materialOrder(data, errorback) {
    return request._get('/shop/order.WaiterOrder/index', data, errorback);
  },
  /*物料订单详情*/
  materialOrderdetail(data, errorback) {
    return request._get('/shop/order.WaiterOrder/detail', data, errorback);
  },
  /*物料订单发货*/
  materialOrderdelivery(data, errorback) {
    return request._get('/shop/order.WaiterOrder/delivery', data, errorback);
  },

}

export default materialApi;



// WEBPACK FOOTER //
// ./src/api/material.js